export default {"src":"/_next/static/media/0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7.fc08aec8.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};